export const BADGE_HOLDER_STATUS_CURRENT = "Current";

const isPast = (value) => {
  if (!value) return false;
  const time = new Date(value).getTime();
  return !Number.isNaN(time) && time <= Date.now();
};

/**
 * Derives the Current / Expired / Terminated / Removed / Obsolete label of a transformed badge-holder row.
 * The row's own `status` is the badge standing (given / good_standing / obsolete), so it cannot be used.
 */
export function resolveBadgeHolderStatus(item) {
  if (!item) return BADGE_HOLDER_STATUS_CURRENT;
  if (String(item.employeeStatus || "").toLowerCase() === "terminated") return "Terminated";
  if (item.cause === "expired") return "Expired";
  if (item.cause || item.removedBy) return "Removed";
  if (isPast(item.badge?.expiration_date)) return "Expired";
  if (item.is_current === false) return "Obsolete";
  return BADGE_HOLDER_STATUS_CURRENT;
}
